import { render, staticRenderFns } from "./collectionManagement.vue?vue&type=template&id=29db73e5&scoped=true"
import script from "./collectionManagement.vue?vue&type=script&lang=js"
export * from "./collectionManagement.vue?vue&type=script&lang=js"
import style0 from "./collectionManagement.vue?vue&type=style&index=0&id=29db73e5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29db73e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29db73e5')) {
      api.createRecord('29db73e5', component.options)
    } else {
      api.reload('29db73e5', component.options)
    }
    module.hot.accept("./collectionManagement.vue?vue&type=template&id=29db73e5&scoped=true", function () {
      api.rerender('29db73e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/collectionManagement.vue"
export default component.exports